import React from "react";
import styles from "./PlanCard.module.scss";
import { Button } from "../../kaya";
import Icon from "../icons";
import { ICONS } from "../../constants/icons.constants";

const PlanCard = (props) => {
  const {
    handleSubmit,
    Title,
    Price,
    Desc,
    Desc2,
    buttonText,
    followUpMessage,
    isFeatured,
  } = props;
  return (
    <div className={`${styles.PlanCard} ${isFeatured ? styles.featured : ""}`}>
      {isFeatured && <div className={styles.popularBadge}>Most Popular</div>}
      <h1 className={styles.title}>{Title}</h1>
      <p className={styles.currency}>{Price}</p>
      <p className={styles.desc}>{Desc2}</p>
      <div className={styles.btn}>
        <Button
          className={styles.btn1}
          type={isFeatured ? "Primary" : "Secondary"}
          onClick={handleSubmit}
        >
          {buttonText || "Get Started"}
        </Button>
      </div>
      {followUpMessage && <p className={styles.followUp}>{followUpMessage}</p>}
      <div className={styles.plandetail}>What’s included:</div>
      <ul>
        {Desc.map((desc, index) => (
          <li className={styles.detail} key={index}>
            <Icon type={ICONS.CHECK_ICON} /> <span>{desc}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PlanCard;
